export const canNavigateAllCountries = (profile = {}) => (
  profile.isFullAdmin === true || profile.paises?.navega === 'ALL'
);

export const getAllowedCountries = (countries = [], profile = {}) => {
  if (canNavigateAllCountries(profile)) return countries;

  const allowedIds = new Set(
    profile.paises?.navega === 'SOME'
      ? (profile.paises.lista || []).map(country => country.id)
      : []
  );

  return countries.filter(country => allowedIds.has(country.id));
};
